import {white} from '@modifi/colors'
import {Row} from '@modifi/ui'
import styled from 'styled-components'

type CardWrapperProps = {
  showCard: boolean
  stickToTop: boolean
}

export const CardWrapper = styled.div<CardWrapperProps>`
  display: flex;
  flex-direction: column;
  width: 384px;
  align-items: flex-start;
  justify-content: ${({stickToTop}): string => (stickToTop ? '' : 'space-between')};
  border-radius: 6px;
  box-shadow: ${({showCard}): string => (showCard ? '3px 4px 16px rgba(23, 61, 108, 0.12)' : '')};
  padding: 16px;
  margin: 8px;
  background-color: ${white};
`

export const StyledRow = styled(Row)`
  margin: 0;
`
